// HTTP for the data-centrifuge coordinator. Mirrors app/stats/page/comments/apiCalls.js:
// the project fetch helpers + AbortController signals, never $.ajax/jQuery. Covers the
// /dqr report fetch, the analyze-job POST, and cs restore/reject.

import { sendRawJSONData, sendJobJSONData } from '@aytm/app/stats/lib/io/fetch'
import { addCSRF } from '@aytm/app/stats/lib/util/helpers'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

// POST <statServerUrl>/dqr?key=… — the synchronous tier-gated aggregate replacing the /raw poll.
export const fetchDataQualityReport = ({ url, apiKey, signal }) =>
  sendJobJSONData({ url: `${url}?key=${apiKey ?? 0}`, method: 'POST', data: {}, signal })

// POST the analyze/run job to the stat job API (same shape as comments runSentiments).
export const fetchDataCentrifugeJob = ({ data, signal }) =>
  sendJobJSONData({ url: PageGlobals.STAT_JOB_API_URL, method: 'POST', data: addCSRF(data), signal })

// POST cs restore — array form hits the bulk endpoint, scalar form the per-uid endpoint.
export const restoreResponses = ({ surveyId, uids, signal }) => {
  const isArray = Array.isArray(uids)
  const url = isArray
    ? `${PageGlobals.AYTM_DOMAIN}/surveys/${surveyId}/cs/restore`
    : `${PageGlobals.AYTM_DOMAIN}/surveys/${surveyId}/cs/${uids}/restore`
  return sendRawJSONData({ url, method: 'POST', data: addCSRF(isArray ? { ids: uids } : {}), signal })
}

// POST cs reject_dc for a single uid with a reason.
export const rejectResponse = ({ surveyId, uid, message, signal }) =>
  sendRawJSONData({
    url: `${PageGlobals.AYTM_DOMAIN}/surveys/${surveyId}/cs/${uid}/reject_dc`,
    method: 'POST',
    data: addCSRF({ message }),
    signal
  })
